import * as React           from "react";
import {useState, Fragment} from "react";

import {LabelAndInputContentProps} from "../../build3.d";

import "../customize-panel.scss";
import "./labelAndInputContent.scss";


export const LabelAndInputContent = ({data, readOnly=false, setUnsavedChanges}: LabelAndInputContentProps) => {

    function createFields(contentField) {

        const [fieldValue, setFieldValue] = useState(contentField.data);

        function changeHandler(event) {
            setUnsavedChanges();
            setFieldValue(event.target.value)
        }

        return (
            <div className="label-and-input-content-dla" key={contentField.idContent}>
                <div className="label-and-input-instance">
                    <div className="label">
                        <div xd-qa-type="label" xd-qa-name={contentField.label}>{contentField.label}</div>
                    </div>
                    <div className="input">
                        <input
                            name={contentField.idContent}
                            data-fieldname={contentField.label}
                            value={readOnly ? contentField.data : fieldValue}
                            onChange={readOnly ? null : changeHandler}
                            readOnly={readOnly}
                            xd-qa-type="text_field"
                            xd-qa-name={contentField.idContent}
                        />
                    </div>
                </div>
            </div>
        )
    }

    return data.map(createFields);

};